// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero-styles-module--hero--3etf9","primaryButton":"Hero-styles-module--primaryButton--2rJRp"};